import { render } from "./PrRouterView.vue?vue&type=template&id=76c16ff3"
import script from "./PrRouterView.vue?vue&type=script&lang=js"
export * from "./PrRouterView.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/projects/panel.doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__